'use es6';

import * as FBData from 'AdsUI/data/FBData';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
export const overrideEngagementLimitForAd = (accountId, adId) => dispatch => wrapReduxAction(FBData.overrideEngagementLimitForAd.bind(FBData, accountId, adId), 'FB_ENGAGEMENTS_OVERRIDE', {
  dispatch,
  startParms: {
    accountId,
    adId
  },
  returnPromise: true
});